/**
 * The desk's address is https://support.aspect.co.uk. Firebase still answers on its own
 * addresses (aspect-support-desk.web.app and .firebaseapp.com); visits there go to the real
 * one, keeping the page and query, so old links and bookmarks still work. Sign-in, cookies and
 * the API's origin checks all belong to the real address.
 */
export const CANONICAL_ORIGIN = "https://support.aspect.co.uk";
const OLD_HOSTS = ["aspect-support-desk.web.app", "aspect-support-desk.firebaseapp.com"];

/** Where to send this visit instead, or null to stay. */
export function canonicalUrl(location: Pick<Location, "hostname" | "pathname" | "search" | "hash">): string | null {
  if (!OLD_HOSTS.includes(location.hostname)) return null;
  return `${CANONICAL_ORIGIN}${location.pathname}${location.search}${location.hash}`;
}
